import { render, staticRenderFns } from "./shop-dialog-selector.vue?vue&type=template&id=62381fac&"
import script from "./shop-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./shop-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./shop-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports